<span [ngClass]="ngClassTextColor">
  {{ requestType() | checkRequestsTypeName }}
</span>
